<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      consulta: null,
      error: false,

    };
  },
  methods: {
    getConsulta() {
      const id = this.$route.params.id;

      api
        .get("consultas/" + id)
        .then((response) => {
          if (response.data.status == "success") {
            this.consulta = response.data.consulta;
          } else {
            this.error = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
  },
  mounted() {
    this.getConsulta();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/consultas">Consultas</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Resultado</li>
    </ol>

    <div class="page-title-box mb-3">
      <h3>Resultado da Consulta</h3>
    </div>

    <!-- Loading -->
    <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!consulta && !error">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <!-- Erro -->
    <div v-else-if="error" class="alert alert-danger">
      Consulta não encontrada.
      <router-link tag="a" to="/consultas" class="alert-link ml-2">Voltar</router-link>
    </div>

    <template v-else-if="consulta">

      <!-- Cabeçalho -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center flex-wrap">
            <span class="badge badge-soft-info font-size-13 text-uppercase mr-3 mb-2">
              {{ consulta.service_name }}
            </span>
            <div class="mr-auto mb-2">
              <h4 class="mb-0">{{ consulta.person_number }}</h4>
              <small class="text-muted text-uppercase">{{ consulta.person_type === 'cpf' ? 'CPF' : 'CNPJ' }}</small>
            </div>
            <div class="text-right mb-2">
              <small class="text-muted d-block">Realizada em</small>
              <span>{{ consulta.date && consulta.date.added }}</span>
            </div>
          </div>

          <hr />

          <!-- Score e status -->
          <div class="row">
            <div class="col-md-4 text-center mb-3 mb-md-0">
              <div class="p-3 border rounded">
                <h1 class="mb-0"
                  :class="{
                    'text-success': consulta.result && consulta.result.score >= 700,
                    'text-warning': consulta.result && consulta.result.score >= 400 && consulta.result.score < 700,
                    'text-danger':  consulta.result && consulta.result.score < 400,
                  }">
                  {{ consulta.result && consulta.result.score || '-' }}
                </h1>
                <small class="text-muted">Score de Crédito</small>
              </div>
            </div>
            <div class="col-md-8 d-flex align-items-center">
              <div>
                <span
                  v-if="consulta.result"
                  :class="consulta.result.status === 'regular' ? 'badge badge-soft-success font-size-14' : 'badge badge-soft-danger font-size-14'"
                  class="text-uppercase mb-2 d-inline-block">
                  {{ consulta.result.status === 'regular' ? 'Regular' : 'Irregular' }}
                </span>
                <p class="text-muted mb-0">
                  <template v-if="consulta.result && consulta.result.status === 'regular'">
                    Nenhuma pendência encontrada para este CPF/CNPJ nos registros do serviço consultado.
                  </template>
                  <template v-else>
                    Foram encontradas pendências para este CPF/CNPJ nos registros do serviço consultado.
                  </template>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pendências -->
      <div class="card" v-if="consulta.result && consulta.result.pendencias && consulta.result.pendencias.length">
        <div class="card-body">
          <h4 class="card-title mb-4">Pendências Encontradas</h4>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap">
              <thead class="thead-light">
                <tr>
                  <th>Origem</th>
                  <th>Valor</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in consulta.result.pendencias" :key="i">
                  <td>{{ p.origem }}</td>
                  <td>{{ p.valor | currency }}</td>
                  <td>{{ p.data }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Documentos PDF -->
      <div class="card" v-if="consulta.result && consulta.result.pdfs && consulta.result.pdfs.length">
        <div class="card-body">
          <h4 class="card-title mb-4">Documentos Disponíveis</h4>
          <div class="list-group">
            <a
              v-for="(pdf, i) in consulta.result.pdfs"
              :key="i"
              :href="pdf.url"
              target="_blank"
              class="list-group-item list-group-item-action d-flex align-items-center"
            >
              <i class="bx bxs-file-pdf text-danger font-size-20 mr-3"></i>
              <span class="flex-grow-1">{{ pdf.nome }}</span>
              <i class="bx bx-download font-size-18 text-muted"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="mt-3 mb-4">
        <router-link tag="a" to="/consultas" class="btn btn-secondary">
          <i class="bx bx-arrow-back mr-1"></i> Voltar
        </router-link>
      </div>
    </template>
  </Layout>
</template>
